import { Button, Stack } from "@mui/material";
import { useTitle } from "../../../hooks/title";

export const AccessDenied = () => {
  useTitle("Access denied · Imagio Color Finder");

  return (
    <Stack alignItems="center" spacing={2} sx={{ padding: "48px 24px" }}>
      <h1>Access denied</h1>
      <p>
        Your account isn't eligible to access Imagio® Color Finder. If you
        believe this is a mistake, please contact your Covestro representative.
      </p>
      <Button variant="contained" href="/">
        Back to Start Page
      </Button>
    </Stack>
  );
};
